import { render, staticRenderFns } from "./GuestItem.vue?vue&type=template&id=371a28a8&scoped=true&"
import script from "./GuestItem.vue?vue&type=script&lang=js&"
export * from "./GuestItem.vue?vue&type=script&lang=js&"
import style0 from "./GuestItem.vue?vue&type=style&index=0&id=371a28a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371a28a8",
  null
  
)

export default component.exports